/**
 * XR Button Handler para Shopify
 * Maneja la configuración del botón XR y muestra un código QR en desktop
 */
(function() {
  // Cargar la biblioteca QRCode.js desde CDN
  function cargarLibreriaQR() {
    return new Promise((resolve, reject) => {
      if (window.QRCode) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Error al cargar QRCode.js'));
      document.head.appendChild(script);
    });
  }

  // Configuración
  const CONFIG = {
    desktopMinWidth: 1024,
    selectors: {
      xrButton: '.product__xr-button',
      xrContainer: '#container-btn-ra',
      containerImage3d: '.container-image-3d'
    },
    qrCode: {
      width: 250,
      height: 250,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: 'H',
      titleText: 'Escanea este código para ver el producto en Realidad Aumentada'
    },
    maxEspera: 12000,
    intervaloReintento: 800
  };

  // Objeto para rastrear estado
  const Estado = {
    botonConfigurado: false,
    contenedorMovido: false,
    duplicadosEliminados: false,
    qrModalCreado: false
  };

  // ===== UTILIDADES =====

  /**
   * Verifica si estamos en vista desktop
   */
  function esDesktop() {
    return window.innerWidth >= CONFIG.desktopMinWidth;
  }

  /**
   * Normaliza una URL para evitar duplicaciones de dominio
   */
  function normalizarUrl(url) {
    try {
      if (!url) return url;

      url = url.replace(/(https?:\/\/)\/+/g, '$1');

      if (!url.startsWith('http')) {
        url = `https://${url.startsWith('//') ? url.substring(2) : url}`;
      }

      const urlObj = new URL(url);
      const hostname = urlObj.hostname;

      if (urlObj.pathname.includes(hostname)) {
        const pathParts = urlObj.pathname.split('/').filter(Boolean);
        let cleanPath = [];
        let foundHostname = false;

        for (const part of pathParts) {
          if (part === hostname || hostname.includes(part) || part.includes(hostname)) {
            foundHostname = true;
            continue;
          }
          if (foundHostname || !hostname.includes(part)) {
            cleanPath.push(part);
          }
        }

        urlObj.pathname = '/' + cleanPath.join('/');
        return urlObj.toString();
      }

      return url;
    } catch (error) {
      return url;
    }
  }

  /**
   * Busca un botón XR usando selector
   */
  function encontrarBotonXR() {
    let selector = CONFIG.selectors.xrButton;
    let boton = document.querySelector(selector);
    if(boton !== null || boton !== 'undefined') {
      return boton;
    }

    return null;
  }

  /**
   * Obtiene la URL óptima para la experiencia AR
   */
  function obtenerUrlAR() {
    try {
      // Variables para almacenar URLs e IDs
      let modelSrc = null;
      let iosSrc = null;
      let modelId = null;
      let shopifyModelId = null;
      
      // 1. Buscar en model-viewer
      const modelViewers = document.querySelectorAll('model-viewer');
      for (const viewer of modelViewers) {
        const viewerIosSrc = viewer.getAttribute('ios-src');
        if (viewerIosSrc) iosSrc = viewerIosSrc;
        
        const viewerSrc = viewer.getAttribute('src');
        if (viewerSrc) modelSrc = viewerSrc;
        
        modelId = viewer.getAttribute('id') || modelId;
      }
      
      // 2. Buscar en elementos Shopify AR
      const arElements = document.querySelectorAll(
        '[data-shopify-xr], [data-shopify-model3d], .shopify-model-viewer-ui'
      );
      
      for (const element of arElements) {
        for (const attr of ['data-model-id', 'data-shopify-model3d-id', 'data-media-id']) {
          const id = element.getAttribute(attr);
          if (id) { shopifyModelId = id; break; }
        }
        
        for (const attr of ['data-model-viewer-src', 'data-src']) {
          const src = element.getAttribute(attr);
          if (src && !modelSrc) modelSrc = src;
        }
      }
      
      // 3. Buscar en scripts
      if (!modelSrc || !iosSrc) {
        const scripts = document.querySelectorAll('script');
        for (const script of scripts) {
          const content = script.textContent || '';
          
          const glbMatch = content.match(/"(https?:\/\/[^"]+\.glb)"/i);
          if (glbMatch && glbMatch[1] && !modelSrc) modelSrc = glbMatch[1];
          
          const usdzMatch = content.match(/"(https?:\/\/[^"]+\.usdz)"/i);
          if (usdzMatch && usdzMatch[1] && !iosSrc) iosSrc = usdzMatch[1];
          
          try {
            if (script.type === 'application/json') {
              const data = JSON.parse(content);
              if (data && data.modelId && !shopifyModelId) shopifyModelId = data.modelId;
              
              if (data && data.product && data.product.media) {
                const mediaItems = Array.isArray(data.product.media) ? data.product.media : [];
                const modelMedia = mediaItems.find(m => 
                  m.media_type === 'model' || 
                  m.type === '3d_model' || 
                  (m.sources && m.sources.some(s => s.format === 'glb' || s.format === 'usdz'))
                );
                
                if (modelMedia) {
                  if (modelMedia.id && !shopifyModelId) shopifyModelId = modelMedia.id;
                  
                  if (modelMedia.sources && Array.isArray(modelMedia.sources)) {
                    for (const source of modelMedia.sources) {
                      if (source.format === 'glb' && source.url && !modelSrc) modelSrc = source.url;
                      if (source.format === 'usdz' && source.url && !iosSrc) iosSrc = source.url;
                    }
                  }
                }
              }
            }
          } catch (e) {
            // Ignorar errores en parsing
          }
        }
      }
      
      // Normalizar URLs
      if (iosSrc) iosSrc = normalizarUrl(iosSrc);
      if (modelSrc) modelSrc = normalizarUrl(modelSrc);
      
      // 4. Extraer información del producto
      const pathParts = window.location.pathname.split('/');
      let productHandle = '';
      
      const productIndex = pathParts.indexOf('products');
      if (productIndex !== -1 && productIndex < pathParts.length - 1) {
        productHandle = pathParts[productIndex + 1];
      } else {
        productHandle = pathParts[pathParts.length - 1];
      }
      
      // 5. Crear URL optimizada
      const storeDomain = window.location.origin;
      
      // Construir URL para máxima compatibilidad
      let optimalUrl;
      if (shopifyModelId) {
        optimalUrl = `${storeDomain}/products/${productHandle}?view=ar&model=${shopifyModelId}&feature=1`;
      } else {
        optimalUrl = `${storeDomain}/products/${productHandle}?view=ar&feature=1`;
      }
      
      return optimalUrl;
    } catch (error) {
      const currentUrl = window.location.href.split('?')[0];
      return `${currentUrl}${currentUrl.includes('?') ? '&' : '?'}view=ar&feature=1`;
    }
  }

  // ===== FUNCIONES PARA QR CODE =====

  /**
   * Crea el modal para mostrar el código QR
   */
  function crearModalQR() {
    if (Estado.qrModalCreado) return;

    // Crear elementos del modal
    const modal = document.createElement('div');
    modal.id = 'ar-qr-modal';
    modal.style.cssText = `
      display: none;
      position: fixed;
      z-index: 9999;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      align-items: center;
      justify-content: center;
    `;

    const modalContent = document.createElement('div');
    modalContent.style.cssText = `
      background-color: white;
      padding: 10px;
      border-radius: 10px;
      max-width: 420px;
      width: 90%;
      text-align: center;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
    `;

    // Título
    const titulo = document.createElement('h3');
    titulo.textContent = CONFIG.qrCode.titleText;
    titulo.style.cssText = `
      margin-top: 0;
      color: #333;
      font-size: 20px;
      font-weight: 600;
    `;

    // Contenedor del QR
    const qrContainer = document.createElement('div');
    qrContainer.id = 'qr-code-container';
    qrContainer.style.cssText = `
      margin-bottom: 20px;
      background-color: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    `;

    // Botón cerrar
    const cerrarBtn = document.createElement('button');
    cerrarBtn.textContent = 'Cerrar';
    cerrarBtn.style.cssText = `
      padding: 10px 25px;
      background-color: #f2f2f2;
      border: 1px solid #ddd;
      border-radius: 5px;
      cursor: pointer;
      font-size: 15px;
      transition: all 0.3s ease;
      margin-top: 10px;
    `;
    cerrarBtn.onmouseover = () => { 
      cerrarBtn.style.backgroundColor = '#e0e0e0'; 
      cerrarBtn.style.borderColor = '#ccc';
    };
    cerrarBtn.onmouseout = () => { 
      cerrarBtn.style.backgroundColor = '#f2f2f2'; 
      cerrarBtn.style.borderColor = '#ddd';
    };
    cerrarBtn.onclick = cerrarModalQR;

    // Ensamblar modal
    modalContent.appendChild(titulo);
    modalContent.appendChild(qrContainer);
    modalContent.appendChild(cerrarBtn);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    // Cerrar al hacer clic fuera del contenido
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        cerrarModalQR();
      }
    });

    // Cerrar con la tecla Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        cerrarModalQR();
      }
    });

    Estado.qrModalCreado = true;
  }

  /**
   * Abre el modal y genera el código QR con instrucciones
   */
  function mostrarModalQR() {
    const modal = document.getElementById('ar-qr-modal');
    if (!modal) return;

    // Abrir modal
    modal.style.display = 'flex';

    // Obtener URL AR optimizada
    const arUrl = obtenerUrlAR();

    // Generar QR Code
    const qrContainer = document.getElementById('qr-code-container');
    qrContainer.innerHTML = ''; // Limpiar contenedor

    // Crear nuevo QR
    try {
      // Contenedor principal para instrucciones y opciones
      const mainContainer = document.createElement('div');
      mainContainer.style.cssText = 'width: 100%;';
      
      // 1. Crear el código QR con la URL optimizada para móviles
      const qrElement = document.createElement('div');
      qrElement.style.cssText = 'margin: 0 auto 15px auto; max-width: 260px;';
      mainContainer.appendChild(qrElement);
      
      new QRCode(qrElement, {
        text: arUrl,
        width: CONFIG.qrCode.width,
        height: CONFIG.qrCode.height,
        colorDark: CONFIG.qrCode.colorDark,
        colorLight: CONFIG.qrCode.colorLight,
        correctLevel: QRCode.CorrectLevel.H
      });
      
      // 2. Instrucciones claras sobre qué hacer
      const instructions = document.createElement('div');
      instructions.style.cssText = 'margin: 0 0 15px 0; padding: 12px; background-color: #f8f9fa; border-radius: 8px; text-align: left;';
      
      const instructionsTitle = document.createElement('h4');
      instructionsTitle.textContent = 'Instrucciones:';
      instructionsTitle.style.cssText = 'margin: 0 0 8px 0; font-size: 15px; color: #333; padding-bottom: 0px;';
      instructions.appendChild(instructionsTitle);
      
      const instructionsList = document.createElement('ol');
      instructionsList.style.cssText = 'margin: 0; padding-left: 20px; font-size: 13px; color: #555; line-height: 1.4;';
      
      const steps = [
        'Escanea el código QR con la cámara de tu dispositivo móvil',
        'Toca en el banner o notificación de AR que aparece',
        'Sigue las instrucciones en pantalla para ver el producto en 3D'
      ];
      
      steps.forEach(step => {
        const li = document.createElement('li');
        li.textContent = step;
        li.style.cssText = 'margin-bottom: 5px;';
        instructionsList.appendChild(li);
      });
      
      instructions.appendChild(instructionsList);
      
      mainContainer.appendChild(instructions);
      
      qrContainer.appendChild(mainContainer);
    } catch (error) {
      qrContainer.innerHTML = '<p style="color: red;">Error al generar el código QR</p>';
    }
  }

  /**
   * Cierra el modal QR
   */
  function cerrarModalQR() {
    const modal = document.getElementById('ar-qr-modal');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  // ===== FUNCIONES PRINCIPALES =====

  /**
   * Configura el botón XR
   * Agregando evento click al botón
   */
  function configurarBotonXR() {
    if (Estado.botonConfigurado) return true;

    const btnXR = document.querySelector(CONFIG.selectors.xrButton);

    const boton = encontrarBotonXR();
    if (!boton) return false;

    try {
      btnXR.addEventListener("click", function(e) {
        if (esDesktop()) {
          e.preventDefault();
          cargarLibreriaQR()
            .then(() => {
              if (!Estado.qrModalCreado) {
                crearModalQR();
              }
              mostrarModalQR();
            })
            .catch(() => {
              if (boton && boton !== btnXR) {
                boton.click();
              }
            });
        } else {
          if (boton && boton !== btnXR) {
            e.preventDefault();
            boton.click();
          }
        }
      });
      
      Estado.botonConfigurado = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Mueve el botón AR al contenedor que debe ir
   */
  function moverBtnAR() {
    if(encontrarBotonXR) {
      const btnXR = document.querySelector(CONFIG.selectors.xrButton);
      const contenedorBtn = document.querySelector(CONFIG.selectors.xrContainer);

      if(contenedorBtn && btnXR) {
        contenedorBtn.appendChild(btnXR);
      }
    }
  }


  /**
   * Mueve el contenedor del botón XR después del contenedor de imagen 3D
   */
  function moverContenedorAR() {
    moverBtnAR();

    const contenedorBtn = document.querySelector(CONFIG.selectors.xrContainer);

    if (!contenedorBtn) return false;

    let contenedorImagen = document.querySelector(CONFIG.selectors.containerImage3d);

    try {
      contenedorImagen.appendChild(contenedorBtn);
      Estado.contenedorMovido = true;
      
      contenedorBtn.style.display = "flex";
      contenedorBtn.style.visibility = "visible";
      contenedorBtn.style.position = "absolute";
      contenedorBtn.style.right = "10px";
      contenedorBtn.style.bottom = "30px";
      contenedorBtn.style.zIndex = "10";
      
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Ejecuta todas las operaciones principales una sola vez
   */
  function ejecutarOperaciones() {    
    configurarBotonXR(),
    moverContenedorAR();
  }

  // ===== INICIALIZACIÓN =====
  
  // Si estamos en desktop, precargar la librería QR
  if (esDesktop()) {
    cargarLibreriaQR().catch(() => {});
  }

  window.addEventListener('load', function() {
    // Ejecutar operaciones inmediatamente
    ejecutarOperaciones();
  });
  
  // Detectar cambios de tamaño de ventana para modo responsivo
  window.addEventListener('resize', function() {
    const esDesktopAhora = esDesktop();
    
    if (!esDesktopAhora) {
      cerrarModalQR();
    }
  });

})();